const formatDuration = (duration, t) => {
  if (duration < 60) {
    return t('{{duration}}sec', { duration: duration });
  } else if (duration % 60 === 0) {
    const minutes = duration / 60;
    return t('{{duration}}min', { duration: minutes });
  } else {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    return t('{{min}}min{{sec}}', {
      min: minutes,
      sec: seconds
    });
  }
};

export default formatDuration;
